<div>
    <div class="flex-container">
        <h1 style="font-weight: 600;">Konto</h1>
        <mat-form-field *ngIf="userservice.currentUser" class="width">
            <input matInput placeholder="E-Mail" [value]="userservice.currentUser.userName" disabled />
        </mat-form-field>

        <button matButton="elevated" color="accent" type="button" class="width" (click)="changePasswordModeToggle()">
            Passwort ändern
        </button>
        <div *ngIf="changePasswordMode" class="grid-change-pw width">
            <form [formGroup]="passwordChangeForm" (keydown.enter)="$event.preventDefault()">
                <div class="gridAbovePW">
                    <mat-form-field class="password-field">
                        <mat-label>Altes Passwort</mat-label>
                        <input matInput type="password" (input)="onCurrentPasswordChange(curPassword.value)"
                            #curPassword [type]="showPassword ? 'text' : 'password'" required />
                        <button mat-icon-button matSuffix (click)="showPassword = !showPassword"
                            [attr.aria-label]="showPassword ? 'Passwort verbergen' : 'Passwort anzeigen'"
                            [attr.aria-pressed]="showPassword">
                            <div class="visibility-icon" [class]="showPassword? 'visibility_off' : 'visibility'"></div>
                        </button>
                    </mat-form-field>
                    <mat-form-field class="password-field">
                        <mat-label>Neues Passwort</mat-label>
                        <input matInput formControlName="password" [formControl]="password"
                            [type]="showPassword ? 'text' : 'password'" required />
                        <button mat-icon-button matSuffix (click)="showPassword = !showPassword"
                            [attr.aria-label]="showPassword ? 'Passwort verbergen' : 'Passwort anzeigen'"
                            [attr.aria-pressed]="showPassword">
                            <div class="visibility-icon" [class]="showPassword? 'visibility_off' : 'visibility'">
                            </div>
                        </button>
                        <mat-error *ngIf="password.hasError('required')">Diese Angabe ist erforderlich</mat-error>
                        <mat-error *ngIf="
                                !password.hasError('required') &&
                                password.hasError('passwordContainsWhitespace')
                            ">Das Passwort darf keine Leerzeichen
                            enthalten</mat-error>
                        <mat-error *ngIf="
                                !password.hasError('required') &&
                                !password.hasError('passwordContainsWhitespace') &&
                                hasPasswordRuleError()
                            ">
                            Ihr Passwort muss mindestens 12 Zeichen, Groß- und Kleinbuchstaben,
                            eine Zahl und ein Sonderzeichen enthalten.
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="password-repeat-field">
                        <mat-label>Neues Passwort wiederholen</mat-label>
                        <input matInput placeholder="Neues Passwort wiederholen" formControlName="confirmpassword"
                            [formControl]="confirmpassword" type="password" [errorStateMatcher]="matcher"
                            [type]="showPassword ? 'text' : 'password'" required />
                        <button mat-icon-button matSuffix (click)="showPassword = !showPassword"
                            [attr.aria-label]="showPassword ? 'Passwort verbergen' : 'Passwort anzeigen'"
                            [attr.aria-pressed]="showPassword">
                            <div class="visibility-icon" [class]="showPassword? 'visibility_off' : 'visibility'">
                            </div>
                        </button>
                        <mat-error *ngIf="confirmpassword.hasError('required')">
                            Diese Angabe ist erforderlich
                        </mat-error>
                        <mat-error
                            *ngIf="passwordChangeForm.hasError('notEqual') && !confirmpassword.hasError('required')">
                            Diese Angabe stimmt nicht mit dem Passwort überein
                        </mat-error>
                    </mat-form-field>
                </div>
                <app-password-strength [password]="password.value"></app-password-strength>
                <div class="buttons mg-top">
                    <button matButton="elevated" color="warn" type="button" (click)="changePasswordModeToggle()">
                        Abbrechen
                    </button>
                    <button matButton="elevated" type="button" color="primary" [disabled]="passwordChangeForm.invalid"
                        (click)="onChangePasswordConfirm()">
                        Speichern
                    </button>
                </div>
            </form>
        </div>

        <!-- <app-hexagon-button-text-icon [text]="'E-Mail Adresse ändern'"
            [icon]="'/assets/img/misc/Kontozusammenfuehren_dark_blue.png'" (click)="changeEmailModeToggle()">
        </app-hexagon-button-text-icon> -->
        <button matButton="elevated" color="accent" type="button" class="width" (click)="changeEmailModeToggle()">
            E-Mail Adresse ändern
        </button>
        <div *ngIf="changeEmailMode" class="grid-change-email width">
            <form [formGroup]="emailChangeForm" (keydown.enter)="$event.preventDefault()">
                <div class="gridAbove">
                    <mat-form-field *ngIf="userservice.currentUser">
                        <mat-label>Aktuelle E-Mail Adresse</mat-label>
                        <input matInput disabled [value]="userservice.currentUser.userName" />
                    </mat-form-field>
                    <mat-form-field class="stretch">
                        <mat-label>Neue E-Mail Adresse</mat-label>
                        <input matInput formControlName="newEmail" [formControl]="newEmail" type="email"
                            autocomplete="email" required pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$" />
                        <mat-error *ngIf="newEmail.errors?.required">Bitte geben sie eine E-Mail an
                        </mat-error>
                        <mat-error *ngIf="newEmail.errors?.pattern">
                            Bitte geben Sie eine valide E-Mail an
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="buttons">
                    <button matButton="elevated" color="warn" type="button" (click)="changeEmailModeToggle()">
                        Abbrechen
                    </button>
                    <button matButton="elevated" color="primary" type="button" [disabled]="emailChangeForm.invalid"
                        (click)="onChangeEmailConfirm()">
                        Speichern
                    </button>
                </div>
            </form>
        </div>

        <!-- <app-hexagon-button-text-icon [text]="'Konto löschen'" [icon]="'/assets/img/icons/Konto_Loeschen_dark_blue.png'"
            (click)="deleteAccountModeToggle()">
        </app-hexagon-button-text-icon> -->
        <button matButton="elevated" color="warn" type="button" class="width" (click)="deleteAccountModeToggle()">
            Konto löschen
        </button>
        <div *ngIf="deleteAccountMode" class="width">
            <form>
                <div class="grid-delete-account">
                    <mat-form-field>
                        <mat-label>Warum möchten Sie ihr Construct-X Konto löschen?</mat-label>
                        <textarea matInput></textarea>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Passwort</mat-label>
                        <input matInput type="password" [formControl]="confirmDeletePassword" required />
                        <mat-error *ngIf="confirmDeletePassword.invalid">Diese Angabe ist erforderlich</mat-error>
                    </mat-form-field>
                    <div class="buttons">
                        <button type="button" matButton="elevated" color="warn" (click)="
                                deleteAccountModeToggle();
                                confirmDeletePassword.reset()
                            ">
                            Abbrechen
                        </button>
                        <button type="button" matButton="elevated" color="warn"
                            [disabled]="confirmDeletePassword.invalid" (click)="onDelete()">
                            Konto löschen
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<div *ngIf="isLoading" class="loading-overlay-spinner">
    <mat-spinner></mat-spinner>
</div>